import get from 'lodash/get';
import set from 'lodash/set';

class BaseSessionStorageState {
  constructor($log, $sessionStorage) {
    this.$sessionStorage = $sessionStorage;
    this.$log = $log;
  }

  /**
   * Saves a value to the part of the session storage set by the subclass.
   *
   * @param {string} path  The path to the variable. Top level variables require only a simple key,
   * but for nested objects use a path separated by periods (e.g. 'maxDisplays.onlinePersons')
   * @param {string} value  The value to be saved
   */
  save(path, value) {
    if (path === undefined || value === undefined) {
      throw new Error("Always provide both key and value for saving.")
    }
    set(this.$sessionStorage[this.storageName], path, value);
    this.$log.debug("Saved state", this.$sessionStorage[this.storageName]);
  }

  /**
   * Retrieves an object from the part of the session storage set by the subclass.
   *
   * @param {string} path  The path to the variable. Top level variables require only a simple key,
   * but for nested objects use a path separated by periods (e.g. 'maxDisplays.onlinePersons')
   *
   * @returns {any} The saved value
   */
  get(path) {
    if (path === undefined) {
      throw new Error("Always provide a key for retrieving value.");
    }
    return get(this.$sessionStorage[this.storageName], path);
  }

  /**
   * Retrieves the whole part of the session storage used by the subclass.
   *
   * @returns {any} The saved state.
   */
  getState() {
    return this.$sessionStorage[this.storageName];
  }

  /**
   * Reset the whole part of the session storage used by the subclass back to defaults.
   */
  reset() {
    this.$sessionStorage[this.storageName] = this.getDefaults();
    this.$log.debug("Reset state", this.$sessionStorage[this.storageName]);
  }
}

export default BaseSessionStorageState;



// WEBPACK FOOTER //
// ./src/app/common/session-storage/base-session-storage-state.js